import { FC, useCallback, useContext, useEffect, useState } from "react";
import { useNavigate, useLocation, matchPath, useParams } from "react-router-dom";

import HubHeader from '../components/header';
import HubFooter from "../components/footer";
// import GuestTopHeader from "src/components/guestTopHeader";
import TawkToMessengerComp from "src/components/tawk.to";

import { AuthContext } from "../context/authContext";
import { AuthenticatedRoutes, ManufacturerRoutes, PublicRoutes ,AreaManagerRoutes} from "../routes/AppRoutes";
import { AppRoute } from "src/routes/types";
import {USER_TYPES} from "../constants";
import { parse } from "date-fns";
import CaseProvider from "src/context/caseContext";
import { LOGGED_IN_VIDEO_NAMES } from "src/constants/headerLinks";


const WithHeaderandFooter: FC<{ WrappedComponent: FC }> = ({ WrappedComponent }): JSX.Element => {
  const [mountTawk, updateMount] = useState(false);

  const { isUserAuthorized, isManufacturer, isRestoreCalled, userData, restoreSession } = useContext(AuthContext);
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  //:- specifically for public user
  const { video_name } = useParams();
  const [showBanner, setShowBanner] = useState(false);
    const [closeBanner, setCloseBanner] = useState(false);

    const handleCloseBanner = () => {
    setShowBanner(false); // will reset on refresh or revisit
  };

    const CloseBanner = () => {
        setCloseBanner(false); // will reset on refresh or revisit
    };

  const navigateToTargetedRoute = (RouteListing: AppRoute[]) => {
    //console.log("Test.....")
    // const indexRoute = RouteListing.find((route) => route.isIndex);
    // const currentRoute = RouteListing.find((route) => {
    //   const firstCheck = route.route.includes(pathname);
    //   if (route.route.includes(":")) {
    //     const checkForRoute = route.route.replace(/:([a-z]+)\/?/gi, "/").replace(/\//g, "");
    //     const checkForPathname = pathname.replace(/[0-9]/g, "").replace(/\//g, "");
    //     const secondCheck = checkForRoute === checkForPathname;
    //     return firstCheck || secondCheck;
    //   } else {
    //     return firstCheck;
    //   }
    // });
    const indexRoute = RouteListing.find((route) => route.isIndex);
    const currentRoute = RouteListing.find((route) =>
      matchPath({ path: route.route, end: false }, pathname)
    );

    if (indexRoute) {
      if (isManufacturer && userData && userData.ref_type !== "Manufacturer") {
        if (currentRoute && currentRoute.route.includes("/statistics")) {
          if (!currentRoute.route.includes(userData.id.toString())) navigate(`/statistics/${userData.id}`)
        }
      } else if (userData && USER_TYPES.HCP.includes(userData.ref_type)) {
        if (!userData.baa_viewed || (userData.baa_viewed_date && userData.baa_viewed_date.length > 0 && parse(userData.baa_viewed_date, "MM/dd/yyyy", new Date()) > new Date()))
          navigate("/pages/baa")
        else {
          if (currentRoute) {
            if (currentRoute.route.includes("video")) {
              console.log({LOGGED_IN_VIDEO_NAMES})
              if (video_name && LOGGED_IN_VIDEO_NAMES.includes(video_name))
                navigate(pathname + search);
              else
                navigate(indexRoute.route);
            } else
              navigate(pathname + search);
          } else
            navigate(indexRoute.route);
        }
      } else {
        if (currentRoute) {
          if (currentRoute.route.includes("video")) {
            if (video_name && video_name ==="enrollment_tutorial")
              navigate(pathname + search)
            else
              navigate(indexRoute.route)
          } else {
            navigate(pathname + search);
          }
        }
        else navigate(indexRoute.route);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  const checkForAuthentication = useCallback(() => {
    if (!isUserAuthorized) {
      navigateToTargetedRoute(PublicRoutes);
    } else {
      if (userData?.is_password_changed === false) {
        navigate("/users/createuser");
      } else if (userData?.ref_type === "Manufacturer") {
        navigateToTargetedRoute(ManufacturerRoutes);
      }else if (userData?.ref_type !== "Manufacturer" && isManufacturer){
        navigateToTargetedRoute(AreaManagerRoutes);
      }
       else {
        navigateToTargetedRoute(AuthenticatedRoutes);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserAuthorized]);

  useEffect(() => {
    if (isRestoreCalled) {
      checkForAuthentication();
    } else if (!userData) {
      restoreSession();
    } else {
      navigate(pathname + search);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkForAuthentication, isRestoreCalled]);

  useEffect(() => {
    if (isUserAuthorized && userData && !USER_TYPES.MANUFACTURER.includes(userData.ref_type)) updateMount(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserAuthorized]);



  return (
      <>
        <header className="sticky-top"><HubHeader/></header>
        {showBanner && !isManufacturer && (
          <div className="alert alert-warning auto-save-banner">
            We have added a new auto save feature that allows you to draft a Prescription Start Form submission and
            complete at a later time or date.
            <button type="button" className="btn bi bi-x-lg" onClick={handleCloseBanner}></button>
          </div>
        )}
        {isUserAuthorized && !isManufacturer && closeBanner && (
          <div className="alert feature-banner auto-save-banner text-white">
              We are pleased to inform you that effective December 28th, 2025, Furoscix has been approved for a new
              indication. Please click on the Furoscix Full Prescribing Information link to learn more.
              <a className="ms-2 text-white" href="https://www.furoscix.com/wp-content/uploads/prescribing-information.pdf"
                 target="_blank">
                 http://www.Furoscix.com/prescribing-information.pdf
              </a>
              <button type="button" className="btn bi bi-x-lg text-white" onClick={CloseBanner}></button>
          </div>
        )}

        {pathname === "/cases/new" || pathname.includes("clone") ? (
            <CaseProvider>
              <WrappedComponent/>
            </CaseProvider>
        ) : (
            <WrappedComponent/>
        )}
        {mountTawk ? <TawkToMessengerComp/> : null}
        <HubFooter/>
      </>
  );
}


export default WithHeaderandFooter;
